import styled from 'styled-components';
import { fontTitle, fontBody } from 'Styles/fonts';
import { grey80, black } from 'Styles/colors';

import { CardContent as CardContentOriginal } from '../../../Card/Card';

export const CardContent = styled(CardContentOriginal)`
  display: flex;
  flex-direction: row;
`;

export const CopyContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const Title = styled.h1`
  ${fontTitle(18)};
  color: ${black};
  margin: 0;
  margin-bottom: 4px;
`;

export const Description = styled.p`
  ${fontBody(14)};
  color: ${grey80};
  margin: 0;
`;

export const IconContainer = styled.div`
  color: ${black};
  display: flex;
  align-items: center;
  width: 40px;
  justify-content: center;
`;
